import { formatBalloonCount } from './utils/formatters';
import { IFeatureProperties } from '../../../types/map';

// Мультипин начинается от 2 объявлений: на одиночном пине каунтер не рисуется
export const PIN_COUNTER_MIN_COUNT = 2;
// По макету в каунтере максимум «9+», сколько бы объявлений ни было в точке
export const PIN_COUNTER_MAX_COUNT = 9;

/**
 * Подпись каунтера мультипина или null, если пин одиночный.
 */
export function getPinCounterLabel({ offersCount }: IFeatureProperties): string | null {
  if (!offersCount || offersCount < PIN_COUNTER_MIN_COUNT) {
    return null;
  }

  return formatBalloonCount(offersCount, PIN_COUNTER_MAX_COUNT);
}
